$(() => {
  checkScroll();
  jQuery(window).scroll(function () {
    checkScroll();
  });

  function checkScroll() {
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 100) {
      jQuery(".header").addClass("header-sticky");
    } else {
      jQuery(".header").removeClass("header-sticky");
    }
  }

});
